const steps = [
  {
    number: '01',
    icon: 'ri-calendar-check-line',
    title: 'Book Your Consultation',
    desc: 'Schedule in-person or virtually. Meet Dr. K, share your goals, and explore your options — no pressure, just conversation.',
  },
  {
    number: '02',
    icon: 'ri-file-list-3-line',
    title: 'Get Your Custom Plan',
    desc: 'Using advanced diagnostics, we design a treatment path tailored precisely to your smile, lifestyle, and timeline.',
  },
  {
    number: '03',
    icon: 'ri-sparkling-2-line',
    title: 'Start Your Transformation',
    desc: 'Begin with confidence. We guide you every step until your smile is everything you envisioned.',
  },
];

export default function JourneySection() {
  return (
    <section className="relative bg-[#F7F6F3] py-24 md:py-32 overflow-hidden">
      {/* Subtle editorial background element */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-[0.035]"
        style={{ background: 'radial-gradient(circle, #4C8265 0%, transparent 70%)' }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-20">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="w-8 h-px bg-[#C4A96E]" />
            <span
              className="text-[#C4A96E] text-[10px] tracking-[0.32em] uppercase font-semibold"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              Your Journey
            </span>
            <span className="w-8 h-px bg-[#C4A96E]" />
          </div>
          <h2
            className="text-[42px] md:text-[56px] text-[#1A2118] font-semibold leading-[1.06] mb-5"
            style={{ fontFamily: 'Cormorant Garamond, serif', letterSpacing: '-0.015em' }}
          >
            Three Steps to the<br />
            <span className="font-light italic text-[#4C8265]">Smile You Deserve</span>
          </h2>
          <p
            className="text-[#5A7060] text-base leading-relaxed"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            A simple, transparent process designed entirely around your comfort and lasting results.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 relative mb-16">
          {/* Connector line */}
          <div className="hidden md:block absolute top-[48px] left-[calc(16.67%+40px)] right-[calc(16.67%+40px)] h-px"
            style={{ background: 'linear-gradient(to right, #C4A96E33, #4C826580, #C4A96E33)' }}
          />

          {steps.map((step, idx) => (
            <div key={step.number} className="flex flex-col items-center text-center">
              {/* Circle */}
              <div className={`relative w-24 h-24 flex flex-col items-center justify-center rounded-full z-10 mb-8 ${
                idx === 1
                  ? 'bg-[#1C3528]'
                  : 'bg-white border border-[#E0E8E2]'
              }`}>
                <i className={`${step.icon} text-2xl mb-1 ${idx === 1 ? 'text-[#C4A96E]' : 'text-[#4C8265]'}`} />
                <span
                  className={`text-[10px] font-bold tracking-widest ${idx === 1 ? 'text-white/50' : 'text-[#4C8265]/50'}`}
                  style={{ fontFamily: 'DM Sans, sans-serif' }}
                >
                  {step.number}
                </span>
              </div>

              <h3
                className="text-[#1A2118] font-semibold text-[22px] mb-3"
                style={{ fontFamily: 'Cormorant Garamond, serif' }}
              >
                {step.title}
              </h3>
              <p
                className="text-[#5A7060] text-sm leading-relaxed max-w-[270px]"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                {step.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Emotional reassurance + CTAs */}
        <div className="flex flex-col items-center">
          <p
            className="text-[#5A7060] text-sm mb-7 text-center max-w-sm"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            Orthodontic treatment is one of the best investments you can make — and we&rsquo;re here to make it effortless.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://smilebydrkortez.com/request-appointment"
              target="_blank"
              rel="noopener nofollow"
              className="bg-[#1C3528] hover:bg-[#254535] text-white font-semibold text-sm px-10 py-4 rounded-full whitespace-nowrap cursor-pointer transition-colors duration-200 flex items-center gap-2.5 justify-center"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              Start Your Journey Today
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="https://smilebydrkortez.com/virtual-consult"
              target="_blank"
              rel="noopener nofollow"
              className="border border-[#1C3528]/25 hover:border-[#1C3528]/50 text-[#1C3528] font-medium text-sm px-10 py-4 rounded-full whitespace-nowrap cursor-pointer transition-all duration-200 flex items-center gap-2.5 justify-center"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              <i className="ri-video-line text-[#4C8265]" />
              Virtual Consultation
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
